export class Bomba {
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    nome: string;
    combustivelId: number;
    tanqueId: number;
    hidrometroInicial: number;
    numeroPatrimonio: string;
    automatizado: boolean;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}

export class Hidrometro {
    dataCriacao: string;
    dataUltimaAlteracao: string;
    ativo: boolean;
    atual: boolean;
    data: string;
    hidrometro: number;
    bombaId: number;
    id: number;
    usuarioCriacaoId: number;
    usuarioUltimaAlteracaoId: number;
}


/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/bombas/shared/bomba.model.ts
 **/